module.exports = __webpack_public_path__ + "img/george-opdyke.4aa66cc9.png";